import type { Icon } from "@tabler/icons-react";
import {
  IconBallFootball,
  IconBallTennis,
  IconBallBasketball,
  IconBallVolleyball,
  IconRun,
  IconBallBaseball,
  IconSwimming,
  IconBallAmericanFootball,
  IconCricket,
  IconSkateboard,
  IconLayoutGridFilled,
  IconBeach,
  IconTarget,
  IconBarbellFilled,
  IconPingPong,
  IconTrees,
  IconSoccerField,
  IconBuildingStadium,
  IconMedal,
  IconAccessibleFilled,
  IconGolfFilled,
  IconMapPinFilled,
  IconMonkeybar,
  IconHandGrab,
  IconIceSkating,
  IconDisc,
  IconDiscGolf,
} from "@tabler/icons-react";

export const sportTypeIcons: Record<string, Icon> = {
  soccer_pitch: IconBallFootball,
  tennis_court: IconBallTennis,
  padel_court: IconBallTennis,
  basketball_court: IconBallBasketball,
  volleyball_court: IconBallVolleyball,
  running_track: IconRun,
  baseball_diamond: IconBallBaseball,
  swimming_pool: IconSwimming,
  rugby_pitch: IconBallAmericanFootball,
  field_hockey_pitch: IconBallFootball,
  cricket_pitch: IconCricket,
  skateboard_park: IconSkateboard,
  multi_sport_court: IconLayoutGridFilled,
  beach_volleyball_court: IconBeach,
  petanque_court: IconTarget,
  bocce_court: IconTarget,
  street_workout_area: IconBarbellFilled,
  pickleball_court: IconBallTennis,
  ping_pong_table: IconPingPong,
  american_football_field: IconBallAmericanFootball,
  netball_court: IconBallBasketball,
  handball_court: IconHandGrab,
  ice_hockey_rink: IconIceSkating,
  ultimate_frisbee_field: IconDisc,
  disc_golf_course: IconDiscGolf,
};

export const placeTypeIcons: Record<string, Icon> = {
  park: IconTrees,
  playground: IconMonkeybar,
  sports_complex: IconLayoutGridFilled,
  athletic_field: IconSoccerField,
  stadium: IconBuildingStadium,
  sports_club: IconMedal,
  sports_activity_location: IconAccessibleFilled,
  skateboard_park: IconSkateboard,
  golf_course: IconGolfFilled,
  swimming_pool: IconSwimming,
};

export function getSportIcon(
  sportTypes: string[] | null | undefined,
  primaryType: string | null | undefined,
): Icon {
  if (sportTypes && sportTypes.length >= 2) return IconLayoutGridFilled;
  if (sportTypes && sportTypes.length === 1) {
    return sportTypeIcons[sportTypes[0]!] ?? IconMapPinFilled;
  }
  if (primaryType) {
    return placeTypeIcons[primaryType] ?? IconMapPinFilled;
  }
  return IconMapPinFilled;
}

/** Representative icons shown in the map legend */
export const legendSportIcons: Array<{ icon: Icon; label: string }> = [
  { icon: IconBallFootball, label: "Soccer / Hockey" },
  { icon: IconBallTennis, label: "Tennis / Padel / Pickleball" },
  { icon: IconBallBasketball, label: "Basketball" },
  { icon: IconBallVolleyball, label: "Volleyball" },
  { icon: IconBeach, label: "Beach Volleyball" },
  { icon: IconRun, label: "Running Track" },
  { icon: IconBallBaseball, label: "Baseball" },
  { icon: IconBallAmericanFootball, label: "Rugby" },
  { icon: IconCricket, label: "Cricket" },
  { icon: IconPingPong, label: "Ping Pong" },
  { icon: IconTarget, label: "Petanque" },
  { icon: IconSkateboard, label: "Skateboard" },
  { icon: IconBarbellFilled, label: "Workout" },
  { icon: IconSwimming, label: "Swimming" },
  { icon: IconGolfFilled, label: "Golf" },
  { icon: IconLayoutGridFilled, label: "Multi-sport" },
  { icon: IconMapPinFilled, label: "Other" },
];
